import { dashToUnderscore } from 'Utilities'

import { getRental_rental } from 'Constants/graphql/queries/detail/__generated__/getRental'

import { CaseItemStatus, CaseItemType } from 'Portal/__generated__/globalTypes'

export const getOpenCaseItemId = (
  rental: getRental_rental,
  caseItemTypes: CaseItemType[],
): string | null => {
  // TODO: Get function working without any type
  let caseItem: any

  const findCaseItem = (caseItemType: CaseItemType) => {
    const result = rental.caseItems?.caseItems?.find(
      caseItem =>
        dashToUnderscore(caseItem.caseType) === caseItemType &&
        caseItem.status !== CaseItemStatus.done,
    )

    if (result) {
      caseItem = result
    }
  }

  caseItemTypes.forEach(caseItemType => findCaseItem(caseItemType))

  if (!caseItem) {
    return null
  }

  return caseItem.id
}
